"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunk45FFMD6H_js = require('./chunk-45FFMD6H.js');
var react = require('react');
var r = require('styled-components');
var reactSwitch = require('@radix-ui/react-switch');
var reactAriaComponents = require('react-aria-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var v=`
  --switch-background-color: var(--color-neutral-700);
  --switch-background-color-checked: var(--color-blue-600);
  --switch-background-color-disabled: var(--color-neutral-300);
  --switch-background-color-checked-disabled: var(--color-blurple-300);
  
  --switch-thumb-color: var(--color-neutral-0);
  --switch-thumb-color-disabled: var(--color-neutral-100);
  --switch-thumb-border-color: var(--color-blue-600);
  
  
  [data-theme='dark'] & {    
    --switch-background-color: var(--color-neutral-100);
    --switch-background-color-checked: var(--color-blue-300);
    --switch-background-color-disabled: var(--color-neutral-700);
    --switch-background-color-checked-disabled: var(--color-blurple-800);

    --switch-thumb-color: var(--color-neutral-800);
    --switch-thumb-color-disabled: var(--color-neutral-400);
    --switch-thumb-border-color: var(--color-blue-200);
  }
`,t=r__default["default"](reactSwitch.Thumb)`
  display: block;
  width: 10px;
  height: 10px;
  background-color: var(--switch-thumb-color);
  border-radius: 100%;
  transition: transform 300ms cubic-bezier(0.3, 0.4, 0.3, 0.8),
    width 150ms cubic-bezier(0.33, 0.14, 0.13, 0.1),
    height 150ms cubic-bezier(0.33, 0.14, 0.13, 0.1);
  transform: translateX(4px);
  will-change: transform;

  &[data-state='checked'] {
    transform: translateX(18px);
  }
`,l=r__default["default"](reactSwitch.Root)`
  all: unset;
  max-width: 32px;
  min-width: 32px;
  height: 16px;
  background-color: var(--switch-background-color);
  border-radius: 100px;
  position: relative;
  display: flex;
  align-items: center;

  &:focus::before {
    content: '';
    position: absolute;
    border-radius: 10px;
    box-shadow: 0 0 0 2px var(--switch-thumb-border-color);
    inset: -2px;
  }

  &[data-state='checked'] {
    background-color: var(--switch-background-color-checked);
  }

  &[data-disabled] {
    background-color: var(--switch-background-color-disabled);

    ${t} {
      background-color: var(--switch-thumb-color-disabled);
    }
  }

  &[data-state='checked'][data-disabled] {
    background-color: var(--switch-background-color-checked-disabled);
  }
`,i=r__default["default"](reactAriaComponents.Label)`
  color: var(--foreground-primary);
  font-size: var(--font-size-regular);
  line-height: 1;

  > span {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    max-width: 280px;
    display: block;
  }
`,d=r__default["default"](chunk45FFMD6H_js.d).attrs({size:"small"})`
  color: var(--foreground-secondary);
  margin-top: var(--spacing-x-small);
`,s=r__default["default"].div`
  ${v}
  max-width: 320px;
  display: inline-flex;
  align-items: flex-start;
  gap: var(--spacing-small);
  width: ${({$fullWidth:o})=>o?"320px":"initial"};
  justify-content: space-between;

  &:hover ${t} {
    transform: translateX(3px) scale(1.2);

    &[data-state='checked'] {
      transform: translateX(19px) scale(1.2);
    }
  }
`;var n=react.forwardRef(({label:o="Switch label",description:a,fullWidth:b=!1,defaultChecked:u,disabled:p,...w},m)=>jsxRuntime.jsxs(s,{ref:m,$fullWidth:b,children:[jsxRuntime.jsxs(i,{htmlFor:o,children:[jsxRuntime.jsx("span",{children:o}),a?jsxRuntime.jsx(d,{children:a}):null]}),jsxRuntime.jsx(l,{id:o,defaultChecked:u,disabled:p,"aria-label":o,...w,children:jsxRuntime.jsx(t,{})})]}));n.displayName="Switch";var y=r__default["default"](n)``;

exports.a = y;
